import {
  DefenseAccessAuthorityTypes,
  DefenseAlarmGradeTypes,
  DefenseAlarmStatusTypes,
  DefenseArmStatusTypes,
  DefenseBagTypes,
  DefenseBottomColorTypes,
  DefenseBottomTypes,
  DefenseBrandMotorVehiclesTypes,
  DefenseByPassStatusTypes,
  DefenseChannelTypes,
  DefenseCoatColorTypes,
  DefenseCoatTypes,
  DefenseDoorAlwaysOpenCloseStatusTypes,
  DefenseEventTypes,
  DefenseGenderTypes,
  DefenseGlobalDoorStatusTypes,
  DefenseHandlingStatusTypes,
  DefenseHatTypes,
  DefenseHumanDetectModeTypes,
  DefenseModelMotorVehiclesTypes,
  DefenseModelNonMotorVehiclesTypes,
  DefenseOpenSluiceModeTypes,
  DefensePersonCardTypes,
  DefensePlateColorsTypes,
  DefenseRecordBeardTypes,
  DefenseRecordEmotionTypes,
  DefenseRecordEyesTypes,
  DefenseRecordGlassesTypes,
  DefenseRecordMaskTypes,
  DefenseRecordMouthTypes,
  DefenseUnityTypes,
  DefenseVehicleAccessTypes,
  DefenseVehicleColorsTypes,
  DefenseZoneFaultStatusTypes,
} from '../../services/Defense/Events/types';
import {
  DefenseDeviceCategoryTypes,
  DefenseManufacturerTypes,
} from '../../services/Defense/Devices/types';

const conversionMap: { [key in DefenseEventTypes]?: string } = {
  DEFENSE_NOTIFY_DEVICE_STATUS: 'Status do Dispositivo',
  DEFENSE_NOTIFY_DEVICE_CHANNEL_STATUS: 'Status do Canal do Dispositivo',
  DEFENSE_HANDLE_ALARM: 'Alarme',
  DEFENSE_NOTIFY_ALARM_PICTURE: 'Imagem do Alarme',
  DEFENSE_DOOR_ACCESS_STATUS: 'Status de Acesso da Porta',
  DEFENSE_DOOR_GLOBAL_CONTROL_STATUS: 'Status de Controle Global da Porta',
  DEFENSE_DOOR_ALWAYS_OPEN_CLOSE_STATUS:
    'Status de Sempre Abrir/Fechar da Porta',
  DEFENSE_ADD_PERSON: 'Adicionar Pessoa',
  DEFENSE_UPDATE_PERSON: 'Atualizar Pessoa',
  DEFENSE_DELETE_PERSON: 'Deletar Pessoa',
  DEFENSE_DOOR_ACCESS_CAPTURE_FINGER_PRINT:
    'Captura de Impressão Digital de Acesso da Porta',
  DEFENSE_NOTIFY_ACS_EVENT: 'Evento de Controle de Acesso',
  DEFENSE_OPEN_SLUICE: 'Abrir Comporta',
  DEFENSE_NOTIFY_ALARMS: 'Alarmes',
  DEFENSE_NOTIFY_ADD_VISITOR: 'Adicionar Visitante',
  DEFENSE_NOTIFY_UPDATE_VISITOR: 'Atualizar Visitante',
  DEFENSE_NOTIFY_DELETE_VISITORS: 'Deletar Visitantes',
  DEFENSE_NOTIFY_VISITOR_COUNT_REPORT: 'Relatório de Contagem de Visitantes',
  DEFENSE_NOTIFY_VEHICLE_CAPTURE_INFO: 'Informações de Captura de Veículo',
  DEFENSE_NOTIFY_FACE_INFOS: 'Informações de Face',
  DEFENSE_NOTIFY_HUMAN_INFOS: 'Informações de Humano',
  DEFENSE_NOTIFY_MOTOR_VEHICLE_INFOS: 'Informações de Veículo Motorizado',
  DEFENSE_NOTIFY_NO_MOTOR_VEHICLE_INFOS:
    'Informações de Veículo Não Motorizado',
  DEFENSE_NOTIFY_AREA_ARM_STATUS: 'Status de Armamento da Área',
  DEFENSE_NOTIFY_ZONE_BY_PASS_STATUS: 'Status de Desvio de Zona',
  DEFENSE_NOTIFY_ZONE_FAULT_STATUS: 'Status de Falha de Zona',
  DEFENSE_NOTIFY_SYNC_DEVICE_INFO:
    'Sincronização de Informações do Dispositivo',
};

export const convertEventType = (type: DefenseEventTypes): string => {
  return conversionMap[type] || type;
};

export const findEventTypeByDescription = (
  search: string,
): DefenseEventTypes | undefined => {
  return (Object.entries(conversionMap) as [DefenseEventTypes, string][]).find(
    ([_, value]) => value.toLowerCase() === search.toLowerCase(),
  )?.[0];
};

const alarmGradeMap: { [key in DefenseAlarmGradeTypes]?: string } = {
  HIGH: 'Alto',
  MEDIUM: 'Médio',
  LOW: 'Baixo',
};

export const convertAlarmGrade = (grade: DefenseAlarmGradeTypes): string => {
  return alarmGradeMap[grade] || grade;
};

const alarmStatusMap: { [key in DefenseAlarmStatusTypes]?: string } = {
  ALARM_GENERATION: 'Geração de Alarme',
  ALARM_DISAPPEARANCE: 'Desaparecimento de Alarme',
};

export const convertAlarmStatus = (status: DefenseAlarmStatusTypes): string => {
  return alarmStatusMap[status] || status;
};

const channelTypeMap: { [key in DefenseChannelTypes]?: string } = {
  BULLET_CAMERA: 'Câmera Bullet',
  PTZ_CAMERA: 'Câmera PTZ',
  DOME_CAMERA: 'Câmera Domo',
  EVIDENCE_CAMERA: 'Câmera de Evidência',
  LOCAL_COLLECTION_INPUT: 'Entrada de Coleta Local',
};

export const convertChannelType = (type: DefenseChannelTypes): string => {
  return channelTypeMap[type] || type;
};

const unityTypeMap: { [key in DefenseUnityTypes]?: string } = {
  ENCODING_UNIT: 'Unidade de Codificação',
  DECODING_OUTPUT: 'Saída de Decodificação',
  ALARM_INPUT: 'Entrada de Alarme',
  ALARM_OUTPUT: 'Saída de Alarme',
  ACCESS_CONTROL_UNIT: 'Unidade de Controle de Acesso',
  VOICE_UNIT: 'Unidade de Voz',
  POS_UNIT: 'Unidade POS',
  VIRTUAL_UNIT: 'Unidade Virtual',
  LED_UNIT: 'Unidade LED',
  CVI_ALARM_UNIT: 'Unidade de Alarme CVI',
  ALARM_HUB_UNIT: 'Unidade Central de Alarme',
  AUDIO_LIGHT_ALARM_UNIT: 'Unidade de Alarme com Áudio e Luz',
  LED_SPLIT_SCREEN_UNIT: 'Unidade LED de Tela Dividida',
  PARKING_SPACE_UNIT: 'Unidade de Vaga de Estacionamento',
  EAS_UNIT: 'Unidade EAS',
  LIFT_CONTROL_UNIT: 'Unidade de Controle de Elevador',
};

export const convertUnityType = (type: DefenseUnityTypes): string => {
  return unityTypeMap[type] || type;
};

const handlingStatusMap: { [key in DefenseHandlingStatusTypes]?: string } = {
  HANDLING: 'Em Manutenção',
  SOLVED: 'Resolvido',
  FALSE_ALARM: 'Alarme Falso',
  IGNORED: 'Ignorado',
  NOT_SOLVED: 'Não Resolvido',
};

export const convertHandlingStatus = (
  status: DefenseHandlingStatusTypes,
): string => {
  return handlingStatusMap[status] || status;
};

const doorGlobalStatusMap: { [key in DefenseGlobalDoorStatusTypes]?: string } =
  {
    NORMAL: 'Normal',
    GLOBAL_LOCKING: 'Bloqueio Global',
    GLOBAL_UNLOCKING: 'Desbloqueio Global',
  };

export const convertGlobalDoorStatus = (
  status: DefenseGlobalDoorStatusTypes,
): string => {
  return doorGlobalStatusMap[status] || status;
};

const doorAlwaysOpenCloseStatusMap: {
  [key in DefenseDoorAlwaysOpenCloseStatusTypes]?: string;
} = {
  NORMAL: 'Normal',
  NORMALLY_CLOSED: 'Normalmente Fechado',
  NORMALLY_OPENED: 'Normalmente Aberto',
};

export const convertDoorAlwaysOpenCloseStatus = (
  status: DefenseDoorAlwaysOpenCloseStatusTypes,
): string => {
  return doorAlwaysOpenCloseStatusMap[status] || status;
};

const genderTypeMap: { [key in DefenseGenderTypes]?: string } = {
  UNKNOWN: 'Desconhecido',
  MALE: 'Masculino',
  FEMALE: 'Feminino',
};

export const convertGenderType = (gender: DefenseGenderTypes): string => {
  return genderTypeMap[gender] || gender;
};

const openSluiceModeMap: { [key in DefenseOpenSluiceModeTypes]?: string } = {
  SYSTEM_OPENING: 'Abertura pelo Sistema',
  REMOTE_OPENING: 'Abertura Remota',
  ANY_OPENING: 'Qualquer Tipo de Abertura',
};

export const convertOpenSluiceMode = (
  mode: DefenseOpenSluiceModeTypes,
): string => {
  return openSluiceModeMap[mode] || mode;
};

const recordEyesMap: { [key in DefenseRecordEyesTypes]?: string } = {
  UNKONWN: 'Desconhecido',
  UNRECOGNIZED: 'Não Reconhecido',
  CLOSED: 'Fechado',
  OPENED: 'Aberto',
};

export const convertRecordEyes = (status: DefenseRecordEyesTypes): string => {
  return recordEyesMap[status] || status;
};

const recordGlassesMap: { [key in DefenseRecordGlassesTypes]?: string } = {
  NO: 'Sem Óculos',
  WITH_GLASSES: 'Com Óculos',
  SUNGLASSES: 'Óculos de Sol',
};

export const convertRecordGlasses = (
  status: DefenseRecordGlassesTypes,
): string => {
  return recordGlassesMap[status] || status;
};

const recordMaskMap: { [key in DefenseRecordMaskTypes]?: string } = {
  UNKONWN: 'Desconhecido',
  UNRECOGNIZED: 'Não Reconhecido',
  WITHOUT_MASK: 'Sem Máscara',
  WITH_MASK: 'Com Máscara',
};

export const convertRecordMask = (status: DefenseRecordMaskTypes): string => {
  return recordMaskMap[status] || status;
};

const recordMouthMap: { [key in DefenseRecordMouthTypes]?: string } = {
  UNKONWN: 'Desconhecido',
  UNRECOGNIZED: 'Não Reconhecido',
  CLOSED: 'Fechado',
  OPENED: 'Aberto',
};

export const convertRecordMouth = (status: DefenseRecordMouthTypes): string => {
  return recordMouthMap[status] || status;
};

const recordEmotionMap: { [key in DefenseRecordEmotionTypes]?: string } = {
  SMILE: 'Sorrindo',
  ANGRY: 'Bravo',
  SAD: 'Triste',
  DISGUSTED: 'Enojado',
  SCARED: 'Assustado',
  SURPRISED: 'Surpreso',
  NORMAL: 'Normal',
  LAUGH: 'Rindo',
  HAPPY: 'Feliz',
  CONFUSED: 'Confuso',
  SCREAM: 'Gritando',
};

export const convertRecordEmotion = (
  emotion: DefenseRecordEmotionTypes,
): string => {
  return recordEmotionMap[emotion] || emotion;
};

const recordBeardMap: { [key in DefenseRecordBeardTypes]?: string } = {
  UNKONWN: 'Desconhecido',
  UNRECOGNIZED: 'Não Reconhecido',
  WITHOUT_BEARD: 'Sem Barba',
  WITH_BEARD: 'Com Barba',
};

export const convertRecordBeard = (status: DefenseRecordBeardTypes): string => {
  return recordBeardMap[status] || status;
};

const hatTypeMap: { [key in DefenseHatTypes]?: string } = {
  ALL: 'Todos',
  NO_HAT: 'Sem Chapéu',
  WITH_HAT: 'Com Chapéu',
};

export const convertHatType = (status: DefenseHatTypes): string => {
  return hatTypeMap[status] || status;
};

const coatColorMap: { [key in DefenseCoatColorTypes]?: string } = {
  UNKNOWN: 'Desconhecido',
  WHITE: 'Branco',
  ORANGE: 'Laranja',
  PINK: 'Rosa',
  BLACK: 'Preto',
  RED: 'Vermelho',
  YELLOW: 'Amarelo',
  GRAY: 'Cinza',
  BLUE: 'Azul',
  GREEN: 'Verde',
  PURPLE: 'Roxo',
  BROWN: 'Marrom',
};

export const convertCoatColor = (color: DefenseCoatColorTypes): string => {
  return coatColorMap[color] || color;
};

const coatTypeMap: { [key in DefenseCoatTypes]?: string } = {
  UNKNOWN: 'Desconhecido',
  LONG_SLEEVE: 'Manga Longa',
  SHORT_SLEEVE: 'Manga Curta',
};

export const convertCoatType = (type: DefenseCoatTypes): string => {
  return coatTypeMap[type] || type;
};

const bottomTypeMap: { [key in DefenseBottomTypes]?: string } = {
  UNKNOWN: 'Desconhecido',
  PANTS: 'Calças',
  SHORTS: 'Shorts',
  SKIRTS: 'Saias',
};

export const convertBottomType = (type: DefenseBottomTypes): string => {
  return bottomTypeMap[type] || type;
};

const bottomColorMap: { [key in DefenseBottomColorTypes]?: string } = {
  UNKNOWN: 'Desconhecido',
  WHITE: 'Branco',
  ORANGE: 'Laranja',
  PINK: 'Rosa',
  BLACK: 'Preto',
  RED: 'Vermelho',
  YELLOW: 'Amarelo',
  GRAY: 'Cinza',
  BLUE: 'Azul',
  GREEN: 'Verde',
  PURPLE: 'Roxo',
  BROWN: 'Marrom',
};

export const convertBottomColor = (color: DefenseBottomColorTypes): string => {
  return bottomColorMap[color] || color;
};

const bagTypeMap: { [key in DefenseBagTypes]?: string } = {
  ALL: 'Todos',
  NO_BAG: 'Sem Bolsa',
  WITH_BAG: 'Com Bolsa',
};

export const convertBagType = (type: DefenseBagTypes): string => {
  return bagTypeMap[type] || type;
};

const humanDetectModeMap: { [key in DefenseHumanDetectModeTypes]?: string } = {
  FROM_ATTRIBUTES: 'A partir de Atributos',
  FROM_FEATURES: 'A partir de Características',
};

export const convertHumanDetectMode = (
  mode: DefenseHumanDetectModeTypes,
): string => {
  return humanDetectModeMap[mode] || mode;
};

const plateColorMap: { [key in DefensePlateColorsTypes]?: string } = {
  BLUE: 'Azul',
  YELLOW: 'Amarelo',
  WHITE: 'Branco',
  BLACK: 'Preto',
  GREEN: 'Verde',
  UNRECOGNIZED: 'Não Reconhecido',
  OTHERS: 'Outros',
};

export const convertPlateColor = (color: DefensePlateColorsTypes): string => {
  return plateColorMap[color] || color;
};

const motorVehicleTypeMap: {
  [key in DefenseModelMotorVehiclesTypes]?: string;
} = {
  UNRECOGNIZED: 'Não Reconhecido',
  PUBLIC_BUS: 'Ônibus Público',
  MOTORCYCLE: 'Motocicleta',
  BUS: 'Ônibus',
  LARGE_TRUCK: 'Caminhão Grande',
  MEDIUM_TRUCK: 'Caminhão Médio',
  SEDAN: 'Sedã',
  VAN: 'Van',
  SMALL_TRUCK: 'Caminhão Pequeno',
  MEDIUM_BUS: 'Ônibus Médio',
  SUV: 'SUV',
  MPV: 'MPV',
  PICKUP: 'Picape',
  MINI_SEDAN: 'Mini Sedã',
  OTHER: 'Outro',
};

export const convertMotorVehicleType = (
  type: DefenseModelMotorVehiclesTypes,
): string => {
  return motorVehicleTypeMap[type] || type;
};

const vehicleColorMap: { [key in DefenseVehicleColorsTypes]?: string } = {
  WHITE: 'Branco',
  BLACK: 'Preto',
  RED: 'Vermelho',
  YELLOW: 'Amarelo',
  GRAY: 'Cinza',
  BLUE: 'Azul',
  GREEN: 'Verde',
  PURPLE: 'Roxo',
  PINK: 'Rosa',
  SILVERY: 'Prateado',
  DEEP_ORANGE: 'Laranja Intenso',
  DIM_GRAY: 'Cinza Escuro',
  NOT_RECOGNIZED: 'Não Reconhecido',
  OTHER: 'Outro',
};

export const convertVehicleColor = (
  color: DefenseVehicleColorsTypes,
): string => {
  return vehicleColorMap[color] || color;
};

const nonMotorVehicleTypeMap: {
  [key in DefenseModelNonMotorVehiclesTypes]?: string;
} = {
  UNRECOGNIZED: 'Não Reconhecido',
  TRICYCLE: 'Triciclo',
  BICYCLE: 'Bicicleta',
  VAN_CARGO_TRICYCLE: 'Triciclo de Carga Fechado',
  OPEN_TRICYCLE_WITH_PASSENGER: 'Triciclo Aberto com Passageiro',
  OPEN_TRICYCLE_WITHOUT_PASSENGER: 'Triciclo Aberto sem Passageiro',
  OTHER: 'Outro',
};

export const convertNonMotorVehicleType = (
  type: DefenseModelNonMotorVehiclesTypes,
): string => {
  return nonMotorVehicleTypeMap[type] || type;
};

const personCardTypeMap: { [key in DefensePersonCardTypes]?: string } = {
  GENERAL: 'Geral',
  BLOCKLIST: 'Lista de Bloqueio',
  VISITOR: 'Visitante',
  PATROL: 'Patrulha',
  VIP: 'VIP',
  OTHER: 'Outro',
};

export const convertPersonCardType = (type: DefensePersonCardTypes): string => {
  return personCardTypeMap[type] || type;
};

const brandMotorVehicleMap: {
  [key in DefenseBrandMotorVehiclesTypes]?: string;
} = {
  AUDI: 'Audi',
  HONDA: 'Honda',
  BUICK: 'Buick',
  VOLKSWAGEN: 'Volkswagen',
  TOYOTA: 'Toyota',
  BMW: 'BMW',
  PEUGEOT: 'Peugeot',
  FORD: 'Ford',
  MAZDA: 'Mazda',
  NISSAN: 'Nissan',
  HYUNDAI: 'Hyundai',
  SUZUKI: 'Suzuki',
  CITROEN: 'Citroën',
  BENZ: 'Mercedes-Benz',
  BYD: 'BYD',
  GEELY: 'Geely',
  LEXUS: 'Lexus',
  CHEVROLET: 'Chevrolet',
  CHERY: 'Chery',
  KIA: 'Kia',
  CHARADE: 'Charade',
  DF: 'Dongfeng',
  NAVECO: 'Naveco',
  SGMW: 'SAIC-GM-Wuling',
  JINBEI: 'Jinbei',
  PORSCHE: 'Porsche',
  FERRARI: 'Ferrari',
  LAMBORGHINI: 'Lamborghini',
  JAC: 'JAC Motors',
  CHANGAN: 'Changan',
  GREATWALL: 'Great Wall',
  SKODA: 'Škoda',
  BAOJUN: 'Baojun',
  SUBARU: 'Subaru',
  LANDWIND: 'Landwind',
  LUXGEN: 'Luxgen',
  RENAULT: 'Renault',
  MITSUBISHI: 'Mitsubishi',
  ROEWE: 'Roewe',
  CADILLAC: 'Cadillac',
  MG: 'MG Motor',
  ZOTYE: 'Zotye',
  ZHONGHUA: 'Zhonghua',
  FOTON: 'Foton',
  SONGHUAJIANG: 'Songhuajiang',
  OPEL: 'Opel',
  HONGQI: 'Hongqi',
  FIAT: 'Fiat',
  JAGUAR: 'Jaguar',
  VOLVO: 'Volvo',
  ACURA: 'Acura',
  EMGRAND: 'Emgrand',
  JEEP: 'Jeep',
  BENTLEY: 'Bentley',
  BUGATTI: 'Bugatti',
  CHUANQI: 'Chuanqi',
  DAEWOO: 'Daewoo',
  DONGNAN: 'Dongnan',
  FUDI: 'Fudi',
  HUAPU: 'Huapu',
  HAWTAI: 'Hawtai',
  JMC: 'JMC',
  JINGLONG: 'Jinglong',
  JOYLONG: 'Joylong',
  KARRY: 'Karry',
  CHRYSLER: 'Chrysler',
  ROLLSROYCE: 'Rolls-Royce',
  LINIAN: 'Linian',
  LIFAN: 'Lifan',
  LIEBAO: 'Liebao',
  LINCOLN: 'Lincoln',
  LANDROVER: 'Land Rover',
  LOTUS: 'Lotus',
  MASERATI: 'Maserati',
  MAYBACH: 'Maybach',
  MCLAREN: 'McLaren',
  YOUNGMAN: 'Youngman',
  TESLA: 'Tesla',
  RELY: 'Rely',
  LSUZU: 'Isuzu',
  YIQI: 'Yiqi',
  INFINITI: 'Infiniti',
  YUTONG: 'Yutong',
  ANKAI: 'Ankai',
  CANGHE: 'Canghe',
  HAIMA: 'Haima',
  CROWN: 'Crown',
  HUANGHAI: 'Huanghai',
  JINLV: 'Jinlv',
  JINNING: 'Jinning',
  KUBO: 'Kubo',
  EUROPESTAR: 'Europestar',
  MINI: 'Mini',
  GLEAGLE: 'Gleagle',
  SHIDAI: 'Shidai',
  SHUANGHUAN: 'Shuanghuan',
  TIANYE: 'Tianye',
  WEIZI: 'Weizi',
  ENGLON: 'Englon',
  ZHONGTONG: 'Zhongtong',
  YUEJIN: 'Yuejin',
  TAURUS: 'Taurus',
  ALTO: 'Alto',
  WEIWANG: 'Weiwang',
  CHENGLONG: 'Chenglong',
  HAIGE: 'Haige',
  SHAOLIN: 'Shaolin',
  BEIFANG: 'Beifang',
  BRASILIA: 'Brasilia',
  HAFU: 'Hafu',
  YONGYUAN: 'Yongyuan',
  SHANGQIDATONG: 'Shangqi Datong',
  BEIQIZHIZAO: 'Beiqizhizao',
  YEMA: 'Yema',
  GONOW: 'Gonow',
  HUMMER: 'Hummer',
  ZHONGSHUN: 'Zhongshun',
  SSANGYONG: 'SsangYong',
  HANGTIANCHENGGONG: 'Hangtian Chenggong',
  ASTONMARTIN: 'Aston Martin',
  TECHART: 'TechArt',
  CARLSSON: 'Carlsson',
  SEAT: 'SEAT',
  WIESMANN: 'Wiesmann',
  ALFAROMEO: 'Alfa Romeo',
  SPYKER: 'Spyker',
  MERCURY: 'Mercury',
  SCANIA: 'Scania',
  PROTON: 'Proton',
  LANCIA: 'Lancia',
  PANOZ: 'Panoz',
  HOLDEN: 'Holden',
  ASCARI: 'Ascari',
  DACIA: 'Dacia',
  RENAULTSAMSUNG: 'Renault Samsung',
  VAUXHALL: 'Vauxhall',
  VENTURI: 'Venturi',
  MORGAN: 'Morgan',
  HINO: 'Hino',
  PONTIAC: 'Pontiac',
  KARLABARTH: 'Karl Abarth',
  SATURN: 'Saturn',
  TIANMA: 'Tianma',
  DAIHATSU: 'Daihatsu',
  OLDSMOBILE: 'Oldsmobile',
  SAIBAO: 'Saibao',
  MOSKVICH: 'Moskvich',
  DS: 'DS Automobiles',
  VENUCIA: 'Venucia',
  MITSUOKA: 'Mitsuoka',
  GMG: 'GMG',
  POLONEZ: 'Polonez',
  JIANGNAN: 'Jiangnan',
  LADA: 'Lada',
  SCION: 'Scion',
  DAF: 'DAF',
  YIZHING: 'Yizhing',
  XINKAI: 'Xinkai',
  DADI: 'Dadi',
  TATAMOTORS: 'Tata Motors',
  KAMAZ: 'Kamaz',
  DATSUN: 'Datsun',
  FODEN: 'Foden',
  HERBERTAUSTIN: 'Herbert Austin',
  RONART: 'Ronart',
  HENGTIAN: 'Hengtian',
  DENZA: 'Denza',
  ZINORO: 'Zinoro',
  FORNASARI: 'Fornasari',
  FUQIQITENG: 'Fuqiqiteng',
  QOROS: 'Qoros',
  HUASONG: 'Huasong',
  COWIN: 'Cowin',
  LEVDEO: 'Levdeo',
  LINGZHI: 'Lingzhi',
  NANJINGJINLONG: 'Nanjing Jinlong',
  RUF: 'RUF',
  SHANQITONGJIA: 'Shanqi Tongjia',
  SIMING: 'Siming',
  YUJIE: 'Yujie',
  ZD: 'ZD',
  BAC: 'BAC',
  BORGWARD: 'Borgward',
  CONQUEST: 'Conquest',
  DMC: 'DMC',
  GAZ: 'GAZ',
  GMC: 'GMC',
  KTM: 'KTM',
  NANOFLOWCELL: 'NanoFlowcell',
  NOBLE: 'Noble',
  SSC: 'SSC',
  TRAMONTANA: 'Tramontana',
  ZENVO: 'Zenvo',
  BRABUS: 'Brabus',
  PATTON: 'Patton',
  MELKUS: 'Melkus',
  BQHS: 'BQHS',
  NOT_RECOGNIZED: 'Não Reconhecido',
};

export const convertBrandMotorVehicle = (
  brand: DefenseBrandMotorVehiclesTypes,
): string => {
  return brandMotorVehicleMap[brand] || brand;
};

const armStatusMap: { [key in DefenseArmStatusTypes]?: string } = {
  DISARMED: 'Desarmado',
  ARMED: 'Armado',
  P1_ARMED: 'P1 Armado',
  P2_ARMED: 'P2 Armado',
  P1_P2_ARMED: 'P1 e P2 Armados',
};

export const convertArmStatus = (status: DefenseArmStatusTypes): string => {
  return armStatusMap[status] || status;
};

const byPassStatusMap: { [key in DefenseByPassStatusTypes]?: string } = {
  NORMAL: 'Normal',
  BYPASS: 'Bypass',
  ISOLATED: 'Isolado',
};

export const convertByPassStatus = (
  status: DefenseByPassStatusTypes,
): string => {
  return byPassStatusMap[status] || status;
};

const zoneFaultStatusMap: { [key in DefenseZoneFaultStatusTypes]?: string } = {
  NORMAL: 'Normal',
  TAMPERING: 'Violação',
  SHORT_CIRCUIT: 'Curto-Circuito',
  ANTI_MASKING: 'Anti-Mascaramento',
};

export const convertZoneFaultStatus = (
  status: DefenseZoneFaultStatusTypes,
): string => {
  return zoneFaultStatusMap[status] || status;
};

const deviceCategoryMap: { [key in DefenseDeviceCategoryTypes]?: string } = {
  ENCODER: 'Codificador',
  ALARM_CONTROL_PANEL: 'Painel de Controle de Alarme',
  ANPR: 'ANPR (Reconhecimento Automático de Placas)',
  INTELLIGENCE_DEVICE: 'Dispositivo de Inteligência',
  ACCESS_CONTROL: 'Controle de Acesso',
  POWER_ENV_DEVICE: 'Dispositivo de Energia e Ambiente',
  AUDIO_DEVICE: 'Dispositivo de Áudio',
  TRANSCODER: 'Transcodificador',
  DISPLAY_DEVICE: 'Dispositivo de Exibição',
  VIDEO_CALL_DEVICE: 'Dispositivo de Chamada de Vídeo',
  EMERGENCY_DEVICES: 'Dispositivos de Emergência',
  POS_DEVICES: 'Dispositivos POS',
  NO_CHANNEL_DEVICE: 'Dispositivo Sem Canal',
  DISPLAY_CONTROL_DEVICE: 'Dispositivo de Controle de Exibição',
  LIFT_CONTROL: 'Controle de Elevador',
  NETWORK_DEVICE: 'Dispositivo de Rede',
};

export const convertDeviceCategory = (
  category: DefenseDeviceCategoryTypes,
): string => {
  return deviceCategoryMap[category] || category;
};

const manufacturerMap: { [key in DefenseManufacturerTypes]?: string } = {
  VMS: 'VMS',
  HIKVISION: 'Hikvision',
  AXIS: 'Axis',
  UNIVIEW: 'Uniview',
  BOSCH: 'Bosch',
  JIUZHOU: 'Jiuzhou',
  OTHERS: 'Outros',
};

export const convertManufacturer = (
  manufacturer: DefenseManufacturerTypes,
): string => {
  return manufacturerMap[manufacturer] || manufacturer;
};

const accessAuthorityTypeMap: {
  [key in DefenseAccessAuthorityTypes]?: string;
} = {
  ALLOW_ACCESS: 'Permitir Acesso',
  PROHIBIT_ACCESS: 'Proibir Acesso',
  VERIFY_ACCESS: 'Verificar Acesso',
  VISITOR_INVALID_PERIOD: 'Período de Visitante Inválido',
  SITE_AREA_INSUFFICIENT: 'Área do Local Insuficiente',
  NO_AVAILABLE_PARKING_SPACE: 'Sem Vaga de Estacionamento Disponível',
};

export const convertAccessAuthorityType = (
  type: DefenseAccessAuthorityTypes,
): string => {
  return accessAuthorityTypeMap[type] || type;
};

const vehicleAccessTypeMap: { [key in DefenseVehicleAccessTypes]?: string } = {
  VISITOR: 'Visitante',
  ALLOWLIST: 'Lista Permitida',
  BLOCKLIST: 'Lista de Bloqueio',
  TEMPORARY: 'Temporário',
};

export const convertVehicleAccessType = (
  type: DefenseVehicleAccessTypes,
): string => {
  return vehicleAccessTypeMap[type] || type;
};
